
import { defineComponent, PropType } from 'vue';

// Types
import { RecentSearch } from '@/types/search-results.types';

export default defineComponent({
  name: 'RecentSearch',
  inheritAttrs: false,
  props: {
    searchLink: {
      type: String,
      required: true
    },
    recentSearch: {
      type: Object as PropType<RecentSearch>,
      required: true
    }
  },
  emits: {
    'on-fav-click'(payload: RecentSearch) {
      if ('id' in payload && 'query' in payload && 'faved' in payload) {
        return true;
      }

      return false;
    }
  },
  methods: {
    onClick() {
      this.$emit('on-fav-click', this.recentSearch);
    }
  }
});
